import './App.css';
import axios from 'axios'
import { useState } from 'react';


function App() {

  const [text, setText] = useState("typeb here")
  const [movie, setMovie] = useState([])





  const changeText = (e) => {
    // console.log(e)
    setText(e.target.value)
  }

  const getMovie = (event) => {
    event.preventDefault();

    axios.get(`https://www.omdbapi.com/?s=${text}&apikey=f84363c4`)
      .then((response) => {
        console.log(response.data)
        setMovie(response.data.Search)
      })
  }



  return (
    <>
      <nav className="navbar navbar-expand-lg  navbar-dark bg-dark text-light">
        <div className="container-fluid">
          <a className="navbar-brand" href="#">Movie App</a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a className="nav-link active" aria-current="page" href="#">Home</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#">Link</a>
              </li>
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  Dropdown
                </a>
                <ul className="dropdown-menu">
                  <li><a className="dropdown-item" href="#">Action</a></li>
                  <li><a className="dropdown-item" href="#">Another action</a></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><a className="dropdown-item" href="#">Something else here</a></li>
                </ul>
              </li>
              <li className="nav-item">
                <a className="nav-link disabled">Disabled</a>
              </li>
            </ul>
            <form className="d-flex" role="search" onSubmit={getMovie}>
              <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" value={text} onChange={changeText} />
              <button className="btn btn-outline-success" type="submit">Search</button>
            </form>
          </div>
        </div>
      </nav>






      {/* card */}


      <div className="container">
        <div className="row">
          {
            movie.map((value, index) => {
              return (
                <div className="col-3">
                  <div className="card" style={{ width: '18rem' }}>
                    <img src={value.Poster} className="card-img-top" alt="..." />
                    <div className="card-body">
                      <h5 className="card-title">{value.Title}</h5>
                      <p className="card-text">{value.Year}</p>
                      <a href="#" className="btn btn-primary">Go somewhere</a>
                    </div>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>


    </>
  );
}

export default App;


